<template>
  <div class="dialog" v-if="dialog">

    <b>Dialog:</b> {{ dialog.dialogueId }}<br>

    <span v-if="dialog.channel">
      <b>Channel: </b>
      {{ dialog.channel }}
    </span>
    <br>
    <span v-if="dialog.startTime">
      <b>Zeit: </b>
      {{ dialog.startTime | moment("DD. MMM YYYY // hh:mm") }}
      </span>
      <span v-if="dialog.endTime">
      - {{ dialog.endTime | moment("DD. MMM YYYY // hh:mm") }}
    </span>
    <br>
    <b>Teilnehmer: </b>
    <b-badge variant="light" v-for="(p,j) in dialog.participants" :key="'pa-'+j" class="mr-2">
      {{p.personName}}
    </b-badge>

    <div role="tablist" class="mt-3">
      <b-card no-body class="mb-3" v-for="(u,i) in dialog.utterances" :key="'ut'+i">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block href="#" v-b-toggle="'accordion-'+i" variant="transparent">
            <b-badge class="mr-2" variant="light">{{u.person.personName}}</b-badge>
            <span v-if="u.htmlFragment" v-html="u.htmlFragment"></span>
            <span v-else v-html="u.text"></span>
          </b-button>
        </b-card-header>
        <b-collapse v-bind:id="'accordion-'+i" accordion="dialog-accordion" role="tabpanel">

            <SentenceAnalysis :sentences="u.sentences" :ut="i"></SentenceAnalysis>

        </b-collapse>
      </b-card>
    </div>

  </div>
</template>

<script>
import SentenceAnalysis from '@/components/SentenceAnalysis'

export default {
  name: 'DialogAnalysis',
  components: { SentenceAnalysis },
  computed: {
    dialog () {
      return this.$store.state.dialog;
    }
  }

}
</script>

<style scoped>
  .btn:focus {
    box-shadow: none;
  }
  .nav-pills .nav-link.active {
    background-color: #2d97ba;
  }
</style>
